import { patientDetailChromePatientId } from "./resolvePatientDetailBack";

/**
 * Whether leaving the current patient-detail chrome should be blocked while a
 * visit recording is live. Agenda ↔ Past Visits never blocks.
 *
 * Compares the patient id, not just the route shape: a different patient's
 * chrome matches the same route pattern, so a shape-only check would treat
 * `/patients/1` → `/patients/2` as a tab switch and let it through. The
 * recording shell is an app-level singleton rather than route-scoped, so the
 * new chart would show a live banner for the previous patient's session.
 */
export function shouldBlockPatientChromeLeave(input: {
  isRecordingLive: boolean;
  currentPath: string;
  nextPath: string;
}): boolean {
  if (!input.isRecordingLive) return false;

  const currentPatientId = patientDetailChromePatientId(input.currentPath);
  if (currentPatientId == null) return false;

  return patientDetailChromePatientId(input.nextPath) !== currentPatientId;
}
